import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppTableComponent, Auth, MessagesComponent,  OpnTeamMemberModel,  RequestsService,  RequestStatusUniqueIdentifier,  SearchModel, SearchResultModel, TranslationManager, ViewState } from 'src/common';
import { ActivatedRoute } from '@angular/router';
import { RequestBasicInformationComponent } from '../../request-basic-information/request-basic-information.component';
import { OpnProjectDeadlineListViewModel, OpnProjectDeadlinesListService } from 'src/common/services/requests/opn-steps/opn-projectdeadlines-list';
import { OpnProjectDeadlineListComponent } from './opn-projectdeadline-list';

@Component({
  selector: 'opn-projectdeadlines-list',
  templateUrl: 'opn-projectdeadlines-list.component.html'
})

export class OpnProjectDeadlinesListComponent implements AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @Input() requestId: number;
  @Input() supplierOfferId: number;
  @Input() state: ViewState;
  viewState = ViewState;

  @ViewChild('requestBasicInformationComponent') requestBasicInformationComponent: RequestBasicInformationComponent;
  @ViewChild("opnProjectDeadlineListComponent") opnProjectDeadlineListComponent: OpnProjectDeadlineListComponent;


  constructor(private requestService: RequestsService,
    private opnProjectDeadlinesListService: OpnProjectDeadlinesListService,
    private router: Router,
    private route: ActivatedRoute) { }

  items: OpnProjectDeadlineListViewModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;

  translationManager = TranslationManager;
  requestStatusUniqueIdentifier = RequestStatusUniqueIdentifier;
  // requestStatus: string;

  ngOnInit(): void {
    // ovo ne treba derrad 24.01.2022
    // this.requestService.getRequestStatusUnique(this.requestId).then(result => {
    //   this.requestStatus = result.requestStatus;
    // });
  }

  ngAfterViewInit(): void {
    // this.appTable.onSearch = this.doSearch.bind(this);
    // this.appTable.search();
    this.getAll();
  }

  // doSearch(search: SearchModel) {
  //   this.requestService.opnProjectDeadlinesListSearch(search, this.requestId).then((result: SearchResultModel<OpnProjectDeadlineListViewModel>) => {
  //     this.items = result.items;
  //     //this.appTable.setTotalCount(result.totalCount);
  //   });
  // }

  getAll() {
    this.requestService.opnProjectDeadlinesListGetAll(this.supplierOfferId).then(result => {
      this.items = result.filter(a1 => a1.displaysToSuppliers == true);
    })
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  delete() {
    if (this.idForDelete > 0) {
      this.opnProjectDeadlinesListService.delete(this.idForDelete).then(() => {
        this.idForDelete = 0;
        this.showDeleteModal = false;
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  showCreateModal() {
    if (!this.items.some(q => q.deadlineForCompletion === null)) {
      this.opnProjectDeadlineListComponent.createModal(this.requestId).then((success: boolean) => {
        if (success) {
          this.getAll();
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
        }
      });
    } else {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате прво попунити сва обавезна поља у листи')]);
    }
  }

  showEditModal(projectDeadlineEditModel: OpnProjectDeadlineListViewModel) {
    this.opnProjectDeadlineListComponent.editModal(projectDeadlineEditModel,this.requestId).then((success: boolean) => {
      if (success) {
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно измењени')]);
      }
    });
  }

  navigateToCreatePage() {

    if (!this.items.some(q => q.deadlineForCompletion === null)) {
    this.router.navigate(['./opn-projectdeadline-list-create'], {relativeTo: this.route});
    } else {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате прво попунити сва обавезна поља у листи')]);
    }

  }

}
